module.exports = __webpack_public_path__ + "static/media/Icon-circle-close.1ed08ae4.png";